import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Instagram_Glyph_White.svg")